const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://nsuo.fi/portfolio',
  title: 'nSuo',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Nico Suonvieri',
  role: 'ICT Engineering Student',
  picture: 'nsuo-logo.png', // https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png

  description:
    'I\'m a passionate ICT Engineering Student with a keen interest in software development, digital technologies and all kinds of technology. \n\nMainly I\'m interested in programming, virtual production, 3D modeling and lighting design. I have most experience working with Unreal Engine, Blender, and various programming languages. I\'m always eager to learn new skills and take on exciting projects that allow me to apply my knowledge and creativity.',
  resume: 'nsuo_cv.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/nico-suonvieri-2362a7399/',
    github: 'https://github.com/NicoSuo',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  //
  // Gallery features:
  // - Single image: Use 'image' property for a fallback single image
  // - Multiple images: Use 'sections' array with 'images' property
  // - Images automatically adapt layout:
  //   * 1 image: Centered, larger display (16:9 aspect ratio)
  //   * 2 images: Side-by-side on larger screens
  //   * 3+ images: Responsive grid layout (16:10 aspect ratio)
  // - Each image can have: src (required), caption (optional), link (optional)


  
  { // FROSTBIT PROJECT
    name: 'Frostbit Software Lab',
    description: 'Projects I have worked on at Frostbit, showcasing my contributions in virtual production, 3D modeling, and programming.',
    stack: ['Virtual Production', '3D modeling', 'Blender', 'Programming', 'Unreal Engine', 'Substance Painter', 'Azure DevOps', 'Git'],
    livePreview: 'https://www.frostbit.fi/en/home/',
    image: 'frostbit_logo_white.png',
    sections: [
      // Each section can have a title, text, and an array of images with optional captions and links
      { // Overview of projects
        title: 'Frostbit Projects',
        text: 'Projects I have worked on at Frostbit, showcasing my contributions in virtual production, 3D modeling, and programming.',
        images: [
          { src: 'VPST_Logo_eng.png', 
            caption: 'Virtual Studio Production Technologies project (VPST)',
            text: '2024-2025 | Virtual Production tech & Unreal Engine Generalist',
            link: 'https://www.vtst.fi/',
            modalText: 'Worked as Virtual Production tech for the Virtual Studio Production Technologies project. Created virtual environments and assets using Unreal Engine. Configured & controlled virtual production environments with UE5 & Assimilate Live FX. Developed workflows for the newly established virtual production studio in Lapland University. This project was funded by the European Regional Development Fund and the Regional Council of Lapland, and it was a collaboration between Frostbit, Lapland University, and other industry partners.'
          },
          {
            src: 'PureAirVis.jpg',
            caption: 'Pure Air Visualization project',
            link: 'https://www.frostbit.fi/en/portfolio/pure-air/',
            text: '2022 | Photogrammetry & 3D modeling',
          },
          {
            src: 'EnergyECS.jpg',
            caption: 'Energy ECS project',
            link: 'https://www.frostbit.fi/en/portfolio/energy-ecs/',
            text: '2022 | 3D modeling',
          }          
        ]
      },
      {
        title: 'VPST Project Overview',
        text: '',
        images: [
          {
            src : 'VTST1.jpg',
            caption: 'VPST Project TP2, Flatlight',
            text: '',
            modalText: 'The VPST project was a comprehensive initiative to establish a virtual production studio and develop cutting-edge virtual production technologies. My role involved creating virtual environments and assets using Unreal Engine, configuring and controlling virtual production environments with UE5 and Assimilate Live FX, and developing workflows for the newly established virtual production studio in Lapland University. The project was funded by the European Regional Development Fund and the Regional Council of Lapland, and it was a collaboration between Frostbit, Lapland University, and other industry partners.'
          },
          {
            src: 'VTST_TP2_Flatlight.jpg',
            caption: 'VPST Project TP2, Flatlight',
            text: '',
          },
          {
            src: 'VTST_TP2_Flatlight2.jpg',
            caption: 'VPST Project TP2, Flatlight',
            text: '',
          },
          {
            src: 'VTST_TP2_Workshop.jpg',
            caption: 'VPST Project TP2, Workshop',
            text: '',
          },
          {
            src: 'VTST_TP5_Workshop.jpg',
            caption: 'VPST Project TP5, Workshop',
            text: '',
          },
          {
            src: 'VTST_TP4.jpg',
            caption: 'VPST Project TP4',
            text: '',
          },
          {
            src: 'VTST_TP4_OptiTrack.jpg',
            caption: 'VPST Project TP4, OptiTrack',
            text: '',
          },
        ]
      }
    ],
  },

  { // LYT PROJECT
    name: 'The Student Theatre of Lapland',
    description:
      'Worked as Lighting Designer, Light- & Sound tech & overall Tech in 11 productions. And several in-house events & more!',
    stack: ['Lighting Designer', 'Light Tech', 'Sound Tech', 'Event manager', 'Technical Manager', 'In Board for a year'],
    sourceCode: '',
    livePreview: 'https://www.lapinylioppilasteatteri.fi/',
    image: 'lyt_logo.jpg',
    sections: [
      {
        title: 'Productions I\'ve been part of',
        text: 'A collection of productions I have worked on as part of the Student Theatre of Lapland.',
        images: [
          { 
            src: 'Sardiini.jpg', 
            caption: 'Saako olla Sardiini', 
            link: 'https://www.lapinylioppilasteatteri.fi/saako-olla-sardiini',
            text: '2025-2026 | Lighting Designer',
            modalText: 'Lighting Designer for the Finnish version of the popular "Noises off" play. Designed and programmed lighting for 40+ fixtures including practical effects integrated into the set. Created complex cue sequences for this fast-paced comedy.'
          },
          { 
            src: 'Rakkaat-tytot.jpeg', 
            caption: 'Rakkaat Tytöt', 
            link: 'https://www.lapinylioppilasteatteri.fi/rakkaat-tytot', 
            text: '2025 | Lighting Designer',
            modalText: 'Lighting Designer for "Rakkaat Tytöt". Designed the lights to be reflective of 4 different personas of main characters. '
          },
          { 
            src: '1984.jpg', 
            caption: '1984', 
            link: 'https://www.lyt.fi/1984', 
            text: '2025 | Overall tech & Unreal Engine programmer',
            modalText: '2025 | Overall tech & Worked as Unreal Engine programmer for custom nDisplay media implementation & play system. Programmed lights to 2025 S.Y.T.Y festival.'
          },
          { 
            src: 'sivuja.png', 
            caption: 'Sivuja', 
            link: 'https://www.lapinylioppilasteatteri.fi/sivuja-valkoisesta', 
            text: '2024 | Technical support & Lighting assistant',
            modalText: 'Provided technical support for lighting design and programming. Adapted the lighting setup to meet the requirements of the Helsinki 2025 S.Y.T.Y festival as part of the OFF-program.'
          },
          { 
            src: 'Uudenkarheat.jpg', 
            caption: 'Uudenkarheat (Rollo)', 
            link: 'https://www.lapinylioppilasteatteri.fi/uudenkarheat', 
            text: '2024 | Tech mentor for new tech members.',
            modalText: 'Mentored new tech members in both lighting and sound. This was the first production where we started using the GrandMa 2 console.'
          },
          { 
            src: 'Peppi.jpg', 
            caption: 'Peppi Pitkätossu', 
            link: 'https://www.lapinylioppilasteatteri.fi/peppi', 
            text: '2024 | Sound Tech',
            modalText: 'Worked as Sound Tech. This production included planning, doing & running + mixing all sound with 16 actors with mics. Also won "Theater act of the year" award.'
          },
          { 
            src: 'suuntakysymys.jpg', 
            caption: 'Suuntakysymys', 
            link: 'https://www.lapinylioppilasteatteri.fi/suuntakysymys', 
            text: '2024 | Lighting designer' ,
            modalText: 'Lighting designer for Suuntakysymys where I had strong anchor in "realistic" lighting for that play. This production also went to Vaasa for 2024 S.Y.T.Y festival.'
          },
          { 
            src: 'KRS.png', 
            caption: 'Kerran Rantaan Saavuttiin', 
            link: 'https://www.lapinylioppilasteatteri.fi/kerran-rantaan-saavuttiin/', 
            text: '2023 | Lighting Designer' ,
            modalText: 'Worked as Lighting Designer using GrandMa Dot2 Lighting Console. This production also went to Vaasa for 2024 S.Y.T.Y festival.'
          },
          { 
            src: 'Sammo.png', 
            caption: 'Sammo', 
            link: 'https://www.lapinylioppilasteatteri.fi/sammo', 
            text: '2023 | Lighting mentor in Sammo for new tech members.' ,
            modalText: 'Lighting mentor in Sammo for new tech members.'
          },
          { 
            src: 'yksityiskohdat.jpg', 
            caption: 'Yksityiskohdat', 
            link: 'https://www.lapinylioppilasteatteri.fi/yksityiskohdat-klassikon-paluu', 
            text: '2023 | Lighting designer' ,
            modalText: 'First production as lighting designer for Yksityiskohdat which only used conventional fixtures & old DLite 48 lighting console. This also went to Nattlös festival in Sweden\'s side of border.'
          },
          { 
            src: 'ohjaus.jpg', 
            caption: 'Ohjaus', 
            link: 'https://www.lapinylioppilasteatteri.fi/ohjaus/', 
            text: '2023 | Lighting assistant' ,
            modalText: 'First production in theatre as a lighting assistant.'
          },
        ]
      },
    ]
  },

  { // Wiljami By Night
    name: 'Wiljami By Night',
    description: 'Ongoing game project where I work as a main programmer with a small team of 3 creating a game in Unreal Engine. The game is set in theater Wiljami as Teknikko Juntunen is called to do lights for a premiere of a play next day. But things starts to grow weird as the night goes on.',
    stack: ['Unreal Engine 5', 'programming', 'Blueprints', 'C++', '3D modeling', 'Blender', 'Technical design', 'Tech lead', 'Project management', 'Git', 'Github' ],
    livePreview: '',
    image: 'unrealramenclub_512.png',
    sections: [
      // Each section can have a title, text, and an array of images with optional captions and links
      { // Overview of projects
        title: 'Wiljami By Night',
        text: 'All images are from the very early stages of the project and are not final. Visual style is not yet defined and is subject to change. The game is still in early development and we are currently focusing on prototyping and creating the core mechanics of the game. (More images are subject to be displayed)',
        images: [
          { src: 'wbn_3d_logo.jpeg', 
            caption: 'Early 3D logo for Wiljami By Night',
            text: '',
          },
          {
            src: 'wbn_led1.png',
            caption: 'Early render',
            link: '',
            text: '',
          },
          {
            src: 'wbn_loft1.png',
            caption: 'Early screenshot of the loft area',
            link: '',
            text: '',
          },
          {
            src: 'wbn_stage1.png',
            caption: 'Early screenshot of the stage area',
            link: '',
            text: '',
          },
          {
            src: 'wbn_led2.png',
            caption: 'Early render',
            link: '',
            text: '',
          }
        ]
      },
    ],
  },

  { // Freelancing
    name: 'Freelancing',
    description: 'Freelancing as a sound tech, PA system renting, light tech for various smaller events and productions.',
    stack: ['Digital mixing', 'Sound Tech', 'PA system renting', 'Light Tech', 'GrandMa 2', 'MagicQ'],
    livePreview: '',
    image: '',
    sections: [
      {
      src: '',
      title: 'Page under construction',
      text: 'This section is currently work in progress and will be updated soon with more information about my freelancing work. (I always forget to take pictures of the events :D)',
      }
    ]
  },

  { // Own Projects
    name: 'Projects',
    description: 'All kinds of projects I\'ve done.',
    stack: ['',],
    livePreview: '',
    image: '',
    sections: [
      {
        title: 'Page under construction',
        text: 'This section is currently work in progress and will be updated soon with more information about my projects.',
        images: [
          {
          src: 'mainpage.png',
          caption: 'This portfolio page',
          text: '',
          },
        ]
      },
    ]
  },

]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Light Designer & Tech',
  'Sound Tech',
  'Unreal Engine',
  'Blender',
  'Unity',
  'Code Editors',
  'Substance Painter',
  'Github',
  'Git',
  'Wrapping cables',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'nico.suonvieri@gmail.com',
}

export { header, about, projects, skills, contact }
